import { render, staticRenderFns } from "./partyNotice.vue?vue&type=template&id=6992b4f2&scoped=true&"
import script from "./partyNotice.vue?vue&type=script&lang=js&"
export * from "./partyNotice.vue?vue&type=script&lang=js&"
import style0 from "./partyNotice.vue?vue&type=style&index=0&id=6992b4f2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6992b4f2",
  null
  
)

export default component.exports